export default __webpack_public_path__ + "static/media/black-left-arrow.2258c4c0.svg";